var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" "+_vm._s(_vm.authorName)+" shared an "),_c('strong',[_vm._v("article "+_vm._s(_vm.articleTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }